/**
 * Champ de date d'un filtre de période, aux dimensions des autres filtres :
 * pleine largeur au téléphone, 10 rem dès la tablette.
 */
export function ChampDate({
  libelle,
  valeur,
  min,
  max,
  onChange,
}: {
  libelle: string;
  valeur: string;
  min?: string | undefined;
  max?: string | undefined;
  onChange: (valeur: string) => void;
}): JSX.Element {
  return (
    <label className="flex w-full min-w-0 items-center gap-2 sm:w-auto">
      <span className="w-8 shrink-0 text-xs text-codialis-gray sm:w-auto">{libelle}</span>
      <input
        type="date"
        value={valeur}
        min={min}
        max={max}
        onChange={(evenement) => onChange(evenement.target.value)}
        className="min-h-[44px] w-full min-w-0 flex-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-xs sm:w-40 sm:flex-none"
      />
    </label>
  );
}
